import { createContext, Dispatch, SetStateAction } from "react";
import { Material, OrderType, ProfileColor } from "../../types/orderTypes";

interface FieldState<Value> {
  value: Value;
  set: Dispatch<SetStateAction<Value>>;
}

/** Stootbordkeuze: standaard volgt de treden, speciaal is een los product. */
export type RisersMode = "standaard" | "speciaal";

/** Vorm van de trap. Draai en dubbelkwart kunnen alleen bij 100 cm. */
export type Trapvorm = "recht" | "draai" | "dubbelkwart";

/**
 * De configuratie van de trap die in de configurator wordt samengesteld.
 *
 * Hier staan uitsluitend KEUZES. Bedragen horen hier niet meer thuis: die
 * ontstaan in de backend (`POST /pricing/calculate`) en worden gelezen via
 * `usePricing()`. Ook afgeleide aantallen — het aantal stootborden, het aantal
 * bovenaansluitingen — komen uit die berekening, zodat de regel op één plek
 * staat.
 *
 * Montage is geen keuze (er wordt uitsluitend inclusief montage verkocht) en
 * volfineer volgt uit het traptype; die velden staan hier daarom niet meer.
 */
interface Context {
  type: FieldState<OrderType>;
  profileColor: FieldState<ProfileColor>;

  stairMaterial: FieldState<Material>;
  stairColor: FieldState<string>;
  stairAmount: FieldState<number>;
  /** Breedte in cm: 100, 120 of 140. */
  breedte: FieldState<number>;
  /** Alleen bij 100 cm iets anders dan "recht". */
  trapvorm: FieldState<Trapvorm>;

  risersMode: FieldState<RisersMode>;
  specialRiserId: FieldState<string | null>;

  topConnectionCode: FieldState<string>;

  extrasLed: FieldState<boolean>;
  ledMode: FieldState<string>;
  ledCustomText: FieldState<string>;
  /** LED-opties, elk 0 of 1 per trap; alleen bij LED. */
  ledDimmer: FieldState<boolean>;
  ledSensor: FieldState<boolean>;

  extrasPlateau: FieldState<boolean>;
  plateauMaterial: FieldState<Material>;
  plateauSize: FieldState<string>;

  margin: FieldState<number>;

  /** Alleen voor de invoer: toont het vrije tekstveld bij een PVC-kleur. */
  pvcCustomColor: FieldState<boolean>;

  first_name: FieldState<string>;
  last_name: FieldState<string>;
  email: FieldState<string>;
  phone: FieldState<string>;
  street: FieldState<string>;
  house_number: FieldState<string>;
  zipcode: FieldState<string>;
  city: FieldState<string>;
}

const context = createContext({} as Context);

export default context;
